// i18n area 'hci' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.pl-PL.meta.json.
import type { enUS } from './hci'

export const plPL: typeof enUS = {
  hci: {
    ceph: {
      title: 'Klastry Ceph',
      createButton: 'Utwórz klaster Ceph',
      emptyTitle: 'Brak zarządzanych klastrów Ceph',
      emptyBody: 'TVirt wdraża Ceph na węzłach członkowskich i jest jego właścicielem — hiperkonwergentnie z obciążeniem VM. Wystarczy utworzyć klaster: pierwszy monitor i jego manager powstają automatycznie na wybranym węźle kontrolnym — potem rozbudowuje się go o kolejne monitory i urządzenia OSD.',
      pageTitle: 'Klastry Ceph',
      colState: 'Stan',
      colMembers: 'Członkowie',
      colSize: 'Rozmiar',
      colVersion: 'Wersja Ceph',
      sizeCell: '{used} GiB użytych z {total} GiB łącznie',
      phase: {
        'not-deployed': 'Niewdrożony',
        deploying: 'Wdrażanie',
        healthy: 'Sprawny',
        degraded: 'Zdegradowany',
        error: 'Błąd',
        destroying: 'Niszczenie',
        destroyed: 'Zniszczony'
      },
      health: {
        HEALTH_OK: 'Sprawny (HEALTH_OK)',
        HEALTH_WARN: 'Z ostrzeżeniami (HEALTH_WARN)',
        HEALTH_ERR: 'W błędzie (HEALTH_ERR)',
        unknown: 'Jeszcze nieobserwowana',
        observedAt: 'zaobserwowano {time}'
      },
      create: {
        title: 'Utwórz klaster Ceph',
        info: 'Przy tworzeniu nowego klastra Ceph należy wybrać pierwszy węzeł, na którym zostaną zainstalowane role MON i MGR. Trzeba też wskazać, której podsieci używa ruch Ceph: podsieć public obsługuje ogólny ruch sieciowy, a podsieć cluster wewnętrzne repliki między OSD; różne podsieci nie są bezwzględnie konieczne.',
        controlNode: 'Węzeł kontrolny',
        controlNodeHint: 'Węzeł członkowski, na którym powstają pierwsze MON i MGR.',
        publicSubnet: 'Podsieć public',
        publicSubnetHint: 'Podsieć zarejestrowana w IPAM — public_network Ceph. Niezmienna po utworzeniu.',
        clusterSubnet: 'Podsieć cluster',
        clusterSubnetHint: 'Podsieć zarejestrowana w IPAM — cluster_network Ceph (replikacja/backfill).',
        noSubnets: 'Brak zarejestrowanych podsieci — należy je najpierw utworzyć w IPAM',
        sameSubnet: 'Ta sama podsieć dla ruchu public i cluster',
        sameSubnetHint: 'Zaznaczone = sieć cluster (replikacja/backfill) pokrywa się z public. Niezaznaczone = należy wybrać jej podsieć ORAZ adres węzła kontrolnego wewnątrz niej.',
        controlAddress: 'Adres węzła kontrolnego',
        controlAddressHint: 'Adres, jaki IPAM zna dla tego węzła wewnątrz podsieci public.',
        controlClusterAddress: 'Adres cluster węzła kontrolnego',
        controlClusterAddressHint: 'Adres, jaki IPAM zna dla tego węzła wewnątrz podsieci cluster.',
        noAddresses: 'IPAM nie zna żadnego adresu tego węzła wewnątrz wybranej podsieci',
        started: 'Klaster utworzony — bootstrap trwa dalej jako makrotask; faza aktualizuje się sama',
        error: 'Klaster został odrzucony'
      },
      detail: {
        actions: 'Dostępne akcje',
        tabOverview: 'Przegląd',
        tabManagementNodes: 'MON i MGR',
        tabDisks: 'OSD',
        tabPools: 'Pule',
        tabObjects: 'Obiekty',
        tabCrush: 'Mapa CRUSH',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Zaawansowane',
        phase: 'Faza',
        checksTitle: 'Aktywne kontrole kondycji',
        noChecks: 'Brak aktywnych kontroli kondycji',
        checkMuted: 'wyciszona',
        summaryPools: 'Pule',
        summaryFilesystems: 'Systemy plików',
        nodesCard: 'Węzły',
        monHint: 'MGR działa kolokowany z każdym MON. Trzy MON to zalecane kworum; klaster laboratoryjny startuje z jednym. OSD i MDS żyją we własnych kartach.',
        monHintSplit: 'MON i MGR są rozdzielone na tym klastrze (Zaawansowane): każda rola ma własne członkostwo na węzeł. Trzy MON to zalecane kworum; musi istnieć co najmniej jeden MGR.',
        noMons: 'Nie zadeklarowano żadnego monitora',
        addNode: 'Dodaj węzeł',
        removeNode: 'Usuń węzeł',
        removeNodeFrom: 'Usuń węzeł {node} (jego MON i kolokowany MGR)',
        roleMon: 'Rola MON',
        roleMgr: 'Rola MGR',
        roleNa: 'N/A',
        roleNotObserved: 'jeszcze nieobserwowana',
        monInQuorum: 'w kworum',
        monOutQuorum: 'poza kworum',
        mgrActive: 'aktywny',
        mgrStandby: 'standby',
        addRoleMon: 'Dodaj rolę MON',
        removeRoleMon: 'Usuń rolę MON',
        addRoleMgr: 'Dodaj rolę MGR',
        removeRoleMgr: 'Usuń rolę MGR',
        restartMon: 'Zrestartuj usługę MON',
        restartMgr: 'Zrestartuj usługę MGR',
        addMon: 'Dodaj MON',
        removeMon: 'Usuń MON',
        removeMonFrom: 'Usuń rolę MON z węzła {node}',
        addMgr: 'Dodaj MGR',
        removeMgr: 'Usuń MGR',
        removeMgrFrom: 'Usuń rolę MGR z węzła {node}',
        addMds: 'Dodaj MDS',
        removeMds: 'Usuń MDS',
        removeMdsFrom: 'Usuń rolę MDS z węzła {node}',
        mdsSection: 'Serwer metadanych (MDS)',
        noMds: 'Nie zadeklarowano żadnego MDS — system plików wymaga najpierw jednego',
        mdsHint: 'Członkostwo MDS jest osobne od pierwszego dnia: klaster bez CephFS nie deklaruje żadnego, a jeden aktywny plus jeden standby dobrze obsługują system plików. Ceph sam wybiera aktywne i standby spośród zadeklarowanych demonów.',
        mdsActiveFor: 'aktywny — {fs}',
        mdsNotObserved: 'jeszcze nieobserwowany',
        lastMdsGuard: 'Ostatniego MDS nie da się usunąć, dopóki istnieje jakiś system plików — należy najpierw usunąć systemy plików',
        lastMonGuard: 'Ostatniego MON nie da się usunąć — jedynym wyjściem jest zniszczenie klastra',
        lastMgrGuard: 'Ostatniego MGR nie da się usunąć — zarządzany klaster nigdy nie działa bez managera',
        registerDevice: 'Dodaj OSD',
        unregisterDevice: 'Wyrejestruj',
        activeDeviceGuard: 'OSD aktywny — wychodzi przez cykl życia OSD, nie przez rejestr',
        colNode: 'Węzeł',
        devicePhase: { registered: 'Zarejestrowane', active: 'Aktywne' },
        health: 'Kondycja',
        state: 'Stan',
        fsid: 'fsid',
        fsidPending: 'brak — należy ponowić bootstrap',
        version: 'Wersja Ceph',
        publicNetwork: 'Sieć public',
        clusterNetwork: 'Sieć cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Brak dostępnych akcji w tej fazie',
        destroyedNote: 'Klaster zniszczony — wiersz zniknie automatycznie za chwilę'
      },
      overview: {
        services: 'Usługi',
        ok: 'sprawne',
        warning: 'z ostrzeżeniem',
        down: 'niedziałające',
        pgTitle: 'Stany PG',
        pgTotal: 'łącznie {n} PG',
        capacityTitle: 'Miejsce',
        ioTitle: 'Bieżące I/O',
        ioReadBw: 'Przepustowość odczytu',
        ioWriteBw: 'Przepustowość zapisu',
        ioReadIops: 'IOPS odczytu',
        ioWriteIops: 'IOPS zapisu',
        notObserved: 'jeszcze nieobserwowane'
      },
      osd: {
        colId: 'ID',
        colClass: 'Klasa urządzenia',
        colState: 'Stan',
        colSize: 'Rozmiar',
        colPgs: 'PG',
        empty: 'Brak OSD — należy dodać jeden z zadeklarowanego dysku danych',
        markIn: 'Oznacz jako IN',
        markOut: 'Oznacz jako OUT',
        scrub: 'Wykonaj scrub',
        deepScrub: 'Wykonaj głęboki scrub',
        restart: 'Zrestartuj usługę',
        details: 'Szczegóły',
        actionGuard: 'Tylko na aktywnym OSD wdrożonego klastra',
        inTitle: 'Oznacz OSD jako IN',
        inBody: 'osd.{id} wraca do dystrybucji danych (ceph osd in): Ceph równoważy na niego dane.',
        outTitle: 'Oznacz OSD jako OUT',
        outBody: 'osd.{id} wychodzi z dystrybucji danych (ceph osd out): jego dane są równoważone gdzie indziej, a redundancja jest OBNIŻONA, dopóki trwa backfill. Odwracalne w każdej chwili akcją Oznacz jako IN.',
        scrubTitle: 'Zaplanuj scrub',
        scrubBody: 'Zostaje zaplanowany scrub osd.{id}: mon dodaje go do kolejki, a stany PG w kolejnych skanowaniach opowiadają o wyniku.',
        deepScrubTitle: 'Zaplanuj głęboki scrub',
        deepScrubBody: 'Zostaje zaplanowany głęboki scrub osd.{id}: wariant weryfikujący bajty — cięższy dla I/O, ta sama mechanika.',
        restartTitle: 'Zrestartuj usługę OSD',
        restartBody: 'osd.{id} zostaje zatrzymany i uruchomiony ponownie przez nadzór workera na jego węźle.',
        started: 'Akcja uruchomiona — obserwacja aktualizuje się sama',
        error: 'Akcja OSD została odrzucona'
      },
      osdDetail: {
        title: 'Szczegóły OSD',
        tabGeneral: 'Ogólne',
        tabNetwork: 'Sieć',
        tabDevices: 'Urządzenia',
        version: 'Wersja',
        hostname: 'Hostname',
        dataPath: 'Ścieżka danych OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Szyfrowany',
        yes: 'Tak',
        no: 'Nie',
        memory: 'Zużycie pamięci (PSS)',
        pid: 'Identyfikator procesu (PID)',
        front: 'Adres front (klienci i monitory)',
        hbFront: 'Adres heartbeat front',
        back: 'Adres back (OSD)',
        hbBack: 'Adres heartbeat back',
        colDevice: 'Urządzenie',
        colType: 'Typ',
        colPhysical: 'Urządzenie fizyczne',
        colSize: 'Rozmiar',
        volumeTitle: 'Szczegóły woluminu',
        creationTime: 'Data utworzenia',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Nie zaobserwowano żadnego urządzenia dla tego OSD'
      },
      restart: {
        title: 'Zrestartuj usługę',
        monBody: 'Demon MON na węźle {node} zostaje zatrzymany i uruchomiony ponownie przez nadzór workera.',
        mgrBody: 'Demon MGR na węźle {node} zostaje zatrzymany i uruchomiony ponownie przez nadzór workera.',
        started: 'Restart uruchomiony — obserwacja aktualizuje się sama',
        error: 'Restart został odrzucony'
      },
      encryptionMode: {
        alwaysOn: 'Zawsze włączone (dmcrypt)',
        alwaysOff: 'Zawsze wyłączone',
        perOsd: 'Wybór dla każdego OSD',
        section: 'Szyfrowanie OSD at rest',
        title: 'Zmień tryb szyfrowania OSD',
        hint: 'Sposób przygotowania NOWYCH OSD. Istniejące OSD zachowują swój stan per dysk: aby go zmienić, usuwa się OSD i tworzy go od nowa.',
        body: 'Tryb zmienia się na "{mode}" i dotyczy WYŁĄCZNIE NOWYCH OSD: każdy istniejący OSD zachowuje swój obecny stan szyfrowania.',
        apply: 'Zmień tryb',
        error: 'Zmiana trybu została odrzucona'
      },
      pin: {
        address: 'Adres public (opcjonalny pin)',
        clusterAddress: 'Adres cluster (opcjonalny pin)',
        autoPlaceholder: 'automatycznie w podsieci {cidr}',
        hint: 'Adresacja per demon: puste = Ceph sam się przypina wewnątrz zadeklarowanej sieci; wypełnione = ta instancja zostaje przypięta do podanego adresu w swojej sekcji konfiguracji.'
      },
      addMon: {
        title: 'Dodaj węzeł',
        node: 'Węzeł',
        address: 'Adres public',
        addressHint: 'Adresy węzła, jakie IPAM zna wewnątrz podsieci public — automatycznie, gdy istniejąca deklaracja obejmuje ten węzeł.',
        clusterAddress: 'Adres cluster',
        clusterAddressHint: 'Obowiązkowy: podsieć cluster jest osobna, a węzeł nie jest w niej jeszcze zadeklarowany.',
        noAddresses: 'IPAM nie zna żadnego adresu tego węzła wewnątrz podsieci',
        error: 'Dodanie mon zostało odrzucone'
      },
      removeMon: {
        title: 'Usuń MON',
        body: 'MON i kolokowany z nim MGR opuszczają węzeł {node}. Na wdrożonym klastrze demony zostają zatrzymane i usunięte z kworum.',
        error: 'Usunięcie MON zostało odrzucone'
      },
      addMgr: {
        title: 'Dodaj MGR',
        node: 'Węzeł',
        hint: 'Zaawansowane (MON/MGR rozdzielone): samodzielny manager powstaje na wybranym węźle członkowskim wraz z taskiem powinowatym do węzła. Wybór active/standby w Ceph sam wskazuje aktywny MGR.',
        error: 'Dodanie MGR zostało odrzucone'
      },
      removeMgr: {
        title: 'Usuń MGR',
        body: 'Samodzielny MGR opuszcza węzeł {node}. Na wdrożonym klastrze demon zostaje zatrzymany, a jego stan usunięty; MON tego węzła (jeśli istnieje) pozostaje nietknięty.',
        error: 'Usunięcie MGR zostało odrzucone'
      },
      addMds: {
        title: 'Dodaj MDS',
        node: 'Węzeł',
        hint: 'Serwer metadanych CephFS: powstaje na wybranym węźle członkowskim wraz z taskiem powinowatym do węzła, nadzorowany przez workera tak samo jak MON i MGR. Ceph sam wybiera aktywne i standby — jeden aktywny plus jeden standby dobrze obsługują system plików.',
        error: 'Dodanie MDS zostało odrzucone'
      },
      removeMds: {
        title: 'Usuń MDS',
        body: 'MDS opuszcza węzeł {node}. Na wdrożonym klastrze demon zostaje zatrzymany, a jego stan usunięty; API odrzuca usunięcie ostatniego MDS, dopóki potrzebuje go jakiś system plików.',
        error: 'Usunięcie MDS zostało odrzucone'
      },
      split: {
        title: 'MON/MGR rozdzielone',
        label: 'Zezwól na MON i MGR na rozdzielnych węzłach',
        hint: 'Wyłączone (domyślnie) = ratyfikowany standard: MGR działa kolokowany z każdym MON, jedno wspólne członkostwo. Włączone = członkostwo MGR staje się osobne, zarządzane akcjami Dodaj/Usuń MGR w karcie Węzły zarządzania.',
        enable: 'Włącz',
        disable: 'Wyłącz',
        enableBody: 'Członkostwo MGR staje się niezależne od MON, zainicjowane bieżącą kolokacją. Akcje Dodaj/Usuń MGR uzbrajają się w karcie Węzły zarządzania. To rozluźnia domyślne ustawienie platformy — warto je zostawić tylko wtedy, gdy wiadomo, po co.',
        disableBody: 'Powrót do standardowej kolokacji: jeden MGR przy każdym MON, jedno wspólne członkostwo. Legalne tylko wtedy, gdy członkostwo MGR już pokrywa się z MON — należy je najpierw wyrównać akcjami Dodaj/Usuń MGR, w przeciwnym razie API odmówi.',
        error: 'Zmiana została odrzucona'
      },
      rawEditor: {
        title: 'Surowy edytor CRUSH',
        label: 'Pokaż surowy edytor crushmapy w karcie CRUSH',
        hint: 'Wyłączone (domyślnie) = prowadzona powierzchnia reguł jest standardowym narzędziem. Włączone = karta CRUSH pokazuje dodatkowo zdekompilowaną crushmapę jako edytowalny tekst. Zapis zawsze wymaga sudo i nazwy klastra jako potwierdzenia, a przed dotarciem do klastra przechodzi przez compile i test crushtoola.'
      },
      osdFlags: {
        section: 'Globalne flagi OSD',
        title: 'Nadpisanie flag OSD',
        notObserved: 'jeszcze nieobserwowane',
        standardFlowsHint: 'Standardowe przepływy platformy zarządzają tymi flagami samodzielnie w normalnych przypadkach (konserwacja węzła ustawia celowany noout, wymiana dysku przechodzi przez cykl życia OSD). Ta sekcja to ręczne nadpisanie dla operatora, który wie, co robi.',
        notDeployedGuard: 'Flagi OSD istnieją tylko na wdrożonym klastrze',
        set: 'Ustaw flagę',
        unset: 'Zdejmij flagę',
        setBody: 'Globalna flaga {flag} zostanie USTAWIONA na osdmap. Pozostaje, dopóki nie zostanie jawnie zdjęta — zapomniana flaga degraduje samoczynne naprawy klastra.',
        unsetBody: 'Globalna flaga {flag} zostanie ZDJĘTA z osdmap.',
        error: 'Zmiana flagi została odrzucona',
        flag: {
          noout: 'Żaden OSD nie jest oznaczany jako out w dystrybucji danych — brak równoważenia przy utracie demona',
          norebalance: 'Równoważenie danych jest wstrzymane',
          nobackfill: 'Backfill jest wstrzymany',
          norecover: 'Recovery jest wstrzymane',
          pause: 'CAŁE I/O klientów jest wstrzymane (odczyty i zapisy)',
          noin: 'Startujące OSD nie są automatycznie oznaczane jako in',
          nodown: 'Nieosiągalne OSD nie są oznaczane jako down — maskuje prawdziwe awarie'
        }
      },
      pools: {
        section: 'Pule',
        create: 'Utwórz pulę',
        createGuard: 'Pule istnieją tylko na wdrożonym klastrze',
        notObserved: 'Brak obserwacji pul — skanowanie MON zaraportuje je tutaj',
        empty: 'Brak pul na klastrze',
        colName: 'Nazwa',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplikacja',
        colRule: 'Reguła CRUSH',
        colUsage: 'Wykorzystanie',
        observedAtLabel: 'Zaobserwowano',
        objects: 'obiekty: {n}',
        inUseBy: 'w użyciu przez {name}',
        internalGuard: 'Wewnętrzna pula Ceph — platforma nigdy jej nie usuwa',
        delete: 'Usuń pulę',
        deleteGuard: 'Wykorzystywana przez storage {name} — najpierw trzeba usunąć storage',
        hint: 'Tylko pule replikowane (erasure coding poza zakresem v1). Replikacja żyje w Ceph: ta tabela to prawda zaobserwowana przez skanowanie MON.',
        createTitle: 'Utwórz pulę',
        createHint: 'Pula powstaje na klastrze z żądaną replikacją i włączoną aplikacją rbd — pracę wykonuje task na węźle MON. Włączenie opcji "Zaproponuj jako storage" pozwala wykorzystać ją od razu, w tym samym geście.',
        name: 'Nazwa puli',
        nameHint: 'Nazwa bezpieczna dla DNS (małe litery, cyfry, myślniki).',
        size: 'Repliki (size)',
        sizeHint: 'Kopie każdego obiektu. Domyślnie 3.',
        minSize: 'Minimalne repliki (min_size)',
        minSizeHint: 'Minimalna liczba kopii do obsługi I/O — podąża za size − 1, dopóki się jej nie zmieni.',
        createError: 'Utworzenie puli zostało odrzucone',
        deleteTitle: 'Usuń pulę',
        deleteBody: 'Pula {pool} i KAŻDY obiekt w jej wnętrzu zostają nieodwracalnie zniszczone. Aby potwierdzić, należy wpisać nazwę puli.',
        confirmLabel: 'Nazwa puli',
        confirmHint: 'Aby potwierdzić, należy wpisać nazwę puli',
        deleteError: 'Usunięcie puli zostało odrzucone',
        detailTitle: 'Szczegóły puli',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktywny',
        autoscalerOff: 'Nieaktywny',
        autoscalerWarn: 'Powiadomienie',
        pgNumLabel: 'Liczba PG',
        pgNumCaption: 'Obserwowana: autoscaler może ją zmienić samodzielnie — to pole zapisuje życzenie.',
        storage: 'Powiązany storage TVirt',
        addAsStorage: 'Dodaj jako storage TVirt',
        ruleSudoHint: 'Zmiana reguły CRUSH wymaga hasła operatora.',
        updateError: 'Zmiana puli została odrzucona',
        updated: 'Zmiana puli uruchomiona — obserwacja aktualizuje się sama'
      },
      crush: {
        section: 'Reguły CRUSH',
        notObserved: 'Brak jeszcze obserwacji CRUSH — skanowanie MON zaraportuje ją tutaj',
        empty: 'Nie zaobserwowano żadnej reguły na klastrze',
        hint: 'Reguła decyduje, GDZIE trafiają kopie każdego obiektu — jej domena awarii to jednostka, która może ulec awarii bez utraty danych. Pule wskazują na regułę; wbudowana replicated_rule (jedna replika na serwer) jest domyślną od narodzin.',
        create: 'Utwórz regułę',
        createGuard: 'Reguły CRUSH istnieją tylko na wdrożonym klastrze',
        createTitle: 'Utwórz regułę CRUSH',
        createHint: 'Reguła = wybór domeny awarii. Reguła powstaje jako replikowana na domyślnym roocie — pracę wykonuje task na węźle MON; pule wiąże się z nią potem, w karcie Pule.',
        createError: 'Utworzenie reguły zostało odrzucone',
        name: 'Nazwa reguły',
        nameHint: 'Nazwa bezpieczna dla DNS (małe litery, cyfry, myślniki).',
        domain: 'Domena awarii',
        domainChoice: {
          osd: 'Każda replika na innym OSD',
          host: 'Każda replika na innym serwerze',
          rack: 'Każda replika w innym racku'
        },
        domainCustom: 'Własna (kroki wpisane ręcznie)',
        domainOther: 'Każda replika w innym buckecie typu {type}',
        rackGuardHint: 'W obserwowanej hierarchii nie istnieje żaden bucket rack: regułę można mimo to utworzyć, ale żadna pula nie będzie mogła na nią wskazać, dopóki rack nie zostanie zadeklarowany w rozmieszczeniu serwerów członkowskich (ustawienia węzła) — task wyrównania zbuduje bucket, a powiązanie otworzy się samo.',
        treeTitle: 'Obserwowana hierarchia',
        treeNotObserved: 'Brak obserwacji hierarchii — skanowanie MON zaraportuje ją tutaj',
        treeOsds: 'OSD: {n}',
        treeHint: 'Mapa CRUSH tak, jak widzi ją klaster: root → zadeklarowane poziomy → serwer (host) → OSD. Topologia podąża za zadeklarowanym rozmieszczeniem każdego serwera (ustawienia węzła) — zmiana położenia wyrównuje ją poprzez task.',
        unplacedWarning: 'Członkowie bez zadeklarowanego położenia: {nodes} — ich hosty pozostają bezpośrednio pod rootem, poza zadeklarowaną topologią. Położenie deklaruje się w ustawieniach węzła (to ostrzeżenie, nigdy blokada).',
        colName: 'Nazwa',
        colDomain: 'Domena awarii',
        colPools: 'Pule',
        builtinChip: 'wbudowana',
        builtinGuard: 'Domyślna reguła klastra — platforma nigdy jej nie usuwa',
        detailAction: 'Szczegóły reguły',
        detailType: 'Typ',
        backToRules: 'Reguły',
        ruleNotObserved: 'Obserwowana lista reguł nie wymienia tej reguły',
        noPools: 'Żadna pula nie korzysta z tej reguły',
        delete: 'Usuń regułę',
        deleteTitle: 'Usuń regułę CRUSH',
        deleteBody: 'Reguła {rule} zostaje usunięta z crushmapy klastra. Żadna pula nie może z niej korzystać. Aby potwierdzić, należy wpisać nazwę reguły.',
        deleteGuard: 'Korzysta z niej pula {name} — najpierw trzeba przekierować pulę na inną regułę',
        confirmLabel: 'Nazwa reguły',
        confirmHint: 'Aby potwierdzić, należy wpisać nazwę reguły',
        deleteError: 'Usunięcie reguły zostało odrzucone',
        changeRule: 'Zmień regułę CRUSH',
        changeRuleTitle: 'Zmień regułę CRUSH',
        changeRuleHint: 'Pula zaczyna rozmieszczać swoje obiekty według wybranej reguły — Ceph przenosi istniejące dane, aby się do niej dostosować (na pełnej puli następuje równoważenie).',
        changeRuleError: 'Zmiana reguły została odrzucona',
        rule: 'Reguła CRUSH',
        rawTitle: 'Surowa crushmapa (zdekompilowana)',
        rawWarning: 'NIEBEZPIECZEŃSTWO: ten tekst to CAŁA polityka rozmieszczania klastra. Błędna mapa może rozbić placement wszystkich pul naraz. Zapis kompiluje i testuje mapę przy użyciu crushtoola PRZED jej wstrzyknięciem — ale poprawna mapa i tak może być złym pomysłem.',
        rawReload: 'Przeładuj',
        rawLoading: 'Zapytanie w locie — task tylko do odczytu dekompiluje crushmapę…',
        rawSave: 'Zapisz crushmapę',
        rawSaveTitle: 'Wstrzyknij crushmapę',
        rawSaveBody: 'Zmieniony tekst zastępuje crushmapę CAŁEGO klastra po compile i teście crushtoola. Aby potwierdzić, należy wpisać nazwę klastra.',
        rawConfirmLabel: 'Nazwa klastra',
        rawConfirmHint: 'Aby potwierdzić, należy wpisać {name}',
        rawError: 'Operacja na crushmapie nie powiodła się',
        rawHint: 'Tekst ma postać crushtool -d. Błędy kompilacji i testu wracają słowo w słowo z crushtoola — mapa nie dociera do klastra, jeśli któraś z tych dwóch bramek zawiedzie.'
      },
      objects: {
        poolsSection: 'Eksplorator obiektów',
        poolsHint: 'Wybór puli wypisuje jej obrazy RBD. Każdy głęboki odczyt biegnie jako task tylko do odczytu na węźle MON — nie blokuje prawdziwych operacji ani nie jest przez nie blokowany.',
        deployedGuard: 'Zapytania o obiekty odpowiadają tylko na wdrożonym klastrze',
        browse: 'Przeglądaj obiekty',
        detailAction: 'Szczegóły obrazu',
        backToPools: 'Pule',
        backToImages: 'Obrazy',
        refresh: 'Odśwież',
        loading: 'Zapytanie w locie — task tylko do odczytu odpytuje klaster…',
        error: 'Zapytanie nie powiodło się',
        retry: 'Ponów',
        notRbd: 'Pula z aplikacją "{app}" — nie zawiera obrazów RBD, nie ma tu czego eksplorować',
        noImages: 'Brak obrazów RBD w tej puli',
        colImage: 'Obraz',
        colSize: 'Rozmiar',
        colObjects: 'Obiekty',
        colSnapshots: 'Snapshoty',
        imagesHint: 'Dyski na konsumującym storage rbd to obrazy o nazwie swojego id dysku. Liczba obiektów to wartość provisioned (rozmiar / rozmiar obiektu) — rzeczywiste zajęcie żyje w szczegółach obrazu.',
        infoTitle: 'Obraz',
        infoSize: 'Rozmiar wirtualny',
        infoObjects: 'Obiekty (provisioned)',
        infoObjectSize: 'Rozmiar obiektu',
        infoPrefix: 'Prefiks obiektów',
        infoFormat: 'Format',
        infoFeatures: 'Funkcje',
        usageTitle: 'Rzeczywiste zajęcie (rbd du)',
        usageOf: 'z {provisioned} GiB provisioned',
        usageHint: 'Thin z natury: bajty zajmują wyłącznie zapisane obiekty.',
        watchersTitle: 'Watchery',
        noWatchers: 'Brak watcherów — nikt nie ma teraz tego obrazu otwartego',
        snapshotsTitle: 'Snapshoty RBD',
        noSnapshots: 'Brak snapshotów RBD na tym obrazie',
        colSnapshot: 'Snapshot',
        colProtected: 'Chroniony',
        colTimestamp: 'Utworzono',
        protected: 'chroniony',
        mappingTitle: 'Mapowanie fizyczne (zbiór OSD)',
        mappingSampled: 'Próbka {sampled} obiektów z {total} — uczciwe podsumowanie: dla dużych obrazów zbiór zbiega do WSZYSTKICH OSD puli (CRUSH rozprasza obiekty po całej puli).',
        mappingComplete: 'Zmapowano wszystkie obiekty ({total} z {total}).',
        objectQueryTitle: 'Zmapuj pojedynczy obiekt',
        objectName: 'Nazwa obiektu',
        objectHint: 'Nazwy obiektów RADOS mają postać <prefiks>.<indeks 16-hex> — ceph osd map odpowiada numerem PG i trójkami OSD.',
        mapObject: 'Mapuj',
        primary: 'podstawowy: osd.{osd}'
      },
      registerDevice: {
        title: 'Zarejestruj urządzenie OSD',
        hint: 'Na żywym klastrze rejestracja od razu PRZYGOTOWUJE urządzenie: staje się ono OSD BlueStore dzięki automatycznemu taskowi powinowatemu do węzła (nigdy pusty, ratyfikowano 2026-07-24). Urządzenie należy najwyżej do jednego klastra Ceph w całej flocie.',
        disk: 'Dysk danych',
        diskHint: 'Zadeklarowane dyski danych węzła — nazwa i numer seryjny',
        noDeclared: 'Brak zadeklarowanych dysków danych na tym węźle — należy je najpierw zaznaczyć w ustawieniach lokalnych węzła',
        serialHint: 'Numer seryjny urządzenia — jego pin tożsamości',
        encrypted: 'Szyfruj ten OSD (dmcrypt)',
        encryptedHint: 'Wybór per OSD (tryb klastra to "wybór dla każdego OSD"): zamraża się na tym dysku przy rejestracji — późniejsza zmiana trybu nigdy go nie nadpisuje; robi to akcja wiersza szyfruj/odszyfruj.',
        error: 'Rejestracja została odrzucona'
      },
      unregisterDevice: {
        title: 'Wyrejestruj urządzenie',
        body: 'Tylko rejestr: {name} przestaje być kandydatem na OSD tego klastra. Jego bajty pozostają nietknięte.',
        error: 'Wyrejestrowanie zostało odrzucone'
      },
      deploy: {
        action: 'Ponów wdrożenie',
        title: 'Ponów bootstrap',
        body: 'Bootstrap narodzin startuje od nowa z bieżącej konfiguracji: mony wstają, a każde zarejestrowane urządzenie zostaje przygotowane i aktywowane jako OSD BlueStore. Operacja biegnie jako makrotask — faza aktualizuje się sama.',
        started: 'Bootstrap uruchomiony — trwa dalej jako makrotask; faza aktualizuje się sama',
        error: 'Bootstrap został odrzucony'
      },
      propose: {
        action: 'Zaproponuj jako storage',
        title: 'Zaproponuj jako storage',
        hintPool: 'Istniejąca pula {name} staje się storage TVirt: tożsamość cephx ograniczona do puli trafia do keystore, a storage ceph-rbd powstaje gotowy do użycia. Propozycja konsumuje pulę — nigdy jej nie tworzy.',
        hintFs: 'Istniejący system plików {name} staje się storage TVirt: tożsamość cephx ograniczona do systemu plików trafia do keystore, a storage cephfs powstaje gotowy i zamontowany. Propozycja konsumuje system plików — nigdy go nie tworzy.',
        name: 'Nazwa storage',
        nameHint: 'DNS-1123, unikalna w obrębie scope — tożsamość cephx bierze od niej nazwę.',
        path: 'Ścieżka wewnątrz systemu plików',
        pathHint: 'Ścieżka bezwzględna wewnątrz systemu plików, którą storage montuje — w razie wątpliwości /.',
        alsoPropose: 'Zaproponuj od razu jako storage',
        alsoProposePoolHint: 'Po utworzeniu ten sam gest proponuje świeżo powstałą pulę jako storage ceph-rbd — dwa jawne wywołania, jeden dialog.',
        alsoProposeFsHint: 'Po utworzeniu ten sam gest proponuje świeżo powstały system plików jako storage cephfs — dwa jawne wywołania, jeden dialog.',
        guard: 'Zaproponuj jako storage — tylko na sprawnym klastrze',
        started: 'Propozycja przyjęta — storage się materializuje; pojawi się w sekcji Storage',
        submit: 'Utwórz storage',
        error: 'Propozycja została odrzucona'
      },
      fs: {
        section: 'Systemy plików',
        create: 'Utwórz system plików',
        createGuard: 'Systemy plików istnieją tylko na wdrożonym klastrze',
        mdsFirstGuard: 'Najpierw trzeba dodać MDS — system plików bez serwera metadanych rodzi się bezużyteczny',
        notObserved: 'Brak obserwacji systemów plików — skanowanie MON zaraportuje je tutaj',
        empty: 'Brak systemów plików na klastrze',
        colName: 'Nazwa',
        colPools: 'Pule',
        colMds: 'MDS',
        noActiveMds: 'brak aktywnego MDS',
        delete: 'Usuń system plików',
        deleteGuard: 'Wykorzystywany przez storage {name} — najpierw trzeba usunąć storage',
        hint: 'System plików posiada własne pule danych i metadanych (cephfs.<nazwa>.data / .meta): powstają razem z nim i giną razem z nim — removeFs, nigdy ręczne usunięcie puli. Ta tabela to prawda zaobserwowana przez skanowanie MON.',
        createTitle: 'Utwórz system plików',
        createHint: 'System plików powstaje na klastrze wraz ze swoimi dwiema pulami (aplikacja cephfs) i jest obsługiwany przez zadeklarowane MDS — pracę wykonuje task na węźle MON. Włączenie opcji "Zaproponuj jako storage" pozwala wykorzystać go od razu, w tym samym geście.',
        name: 'Nazwa systemu plików',
        nameHint: 'Nazwa bezpieczna dla DNS (małe litery, cyfry, myślniki).',
        sizeHint: 'Repliki OBU rodzących się pul. Domyślnie 3.',
        createError: 'Utworzenie systemu plików zostało odrzucone',
        deleteTitle: 'Usuń system plików',
        deleteBody: 'System plików {fs} i KAŻDY plik w jego wnętrzu zostają nieodwracalnie zniszczone — jego pule danych i metadanych giną razem z nim. Aby potwierdzić, należy wpisać nazwę systemu plików.',
        confirmLabel: 'Nazwa systemu plików',
        confirmHint: 'Aby potwierdzić, należy wpisać nazwę systemu plików',
        deleteError: 'Usunięcie systemu plików zostało odrzucone'
      },
      destroy: {
        action: 'Zniszcz',
        retryAction: 'Ponów usunięcie',
        retryGuard: 'Niszczenie trwa — ponowienie dotyczy niszczenia zakończonego niepowodzeniem (w przeciwnym razie lease odmawia)',
        title: 'Zniszcz klaster',
        body: 'Wdrożony fabric zostaje rozmontowany: każdy demon tego klastra się zatrzymuje, a jego stan systemowy i klucze w keystore zostają zwolnione. Po udanym zniszczeniu klaster jest usuwany automatycznie.',
        confirmLabel: 'Nazwa klastra',
        confirmHint: 'Aby potwierdzić, należy wpisać nazwę klastra',
        wipe: 'Wymaż zarejestrowane urządzenia',
        wipeHint: 'Zaznaczone: sygnatury każdego zarejestrowanego urządzenia zostają wymazane — dane na nich są zniszczone. Niezaznaczone: bajty pozostają nietknięte, a urządzenia wracają do stanu zarejestrowanych.',
        guard: 'Zniszcz — nic nie jest wdrożone',
        started: 'Niszczenie uruchomione — trwa dalej jako makrotask; faza aktualizuje się sama',
        error: 'Zniszczenie zostało odrzucone'
      },
      delete: {
        guard: 'Usuń — tylko niewdrożona konfiguracja (najpierw trzeba zniszczyć)',
        title: 'Usunąć {name}?',
        body: 'Konfiguracja i jej rejestr urządzeń zostają usunięte. Legalne tylko dopóki nic nie jest wdrożone.',
        error: 'Usunięcie zostało odrzucone'
      }
    }
  }
}
